module.exports = __webpack_public_path__ + "img/确认收到.ea6968d8.png";